import { ItemEntity } from '@entities/Item/Types';

export const GetItemUnit = (item: ItemEntity) => {
    const { qty = 0, packaging, unit } = item;

    if (
        typeof packaging === 'object' &&
        packaging !== null &&
        Object.keys(packaging).length === 1
    ) {
        const packagingValue = Object.values(packaging)[0];
        const packagingKey = Object.keys(packaging)[0];
        const total = qty * Number(packagingValue);

        return `${qty} (${unit})/${total.toFixed(0)} (${packagingKey})`;
    }

    return `${qty} (${unit})/${qty} (${unit})`;
};
